import { render, staticRenderFns } from "./KorisnikCreate.vue?vue&type=template&id=2012d8b2&scoped=true&"
import script from "./KorisnikCreate.vue?vue&type=script&lang=js&"
export * from "./KorisnikCreate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2012d8b2",
  null
  
)

export default component.exports